export const navDrawerWidth = 240;
